import { render, staticRenderFns } from "./HeadingUserVP1.vue?vue&type=template&id=6373be6e&scoped=true"
import script from "./HeadingUserVP1.vue?vue&type=script&lang=js"
export * from "./HeadingUserVP1.vue?vue&type=script&lang=js"
import style0 from "./HeadingUserVP1.vue?vue&type=style&index=0&id=6373be6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373be6e",
  null
  
)

export default component.exports